import { Component, OnInit, HostListener } from '@angular/core';
import { AppService } from './../../appservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './app-navbar.component.html',
  styleUrls: ['./app-navbar.component.css']
})
export class AppNavbarComponent implements OnInit {
  isadmin = true;
  isMobile = false;
  mobileMenuOpen = false;
  isMenuOpen = false;

  constructor(public service: AppService, private router: Router) {
    this.isadmin = this.service.isadmin;
  }

  ngOnInit() {
    this.checkMobile();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkMobile();
    if (!this.isMobile) {
      this.mobileMenuOpen = false;
    }
  }

  private checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  public logoff() {
    this.service.islogin = false;
    this.service.removelocalitem('rememberme');
    this.service.removelocalitem('un');
    this.router.navigate(['login']);
  }
}